import { Toast, Dialog } from 'vant';
import {nextTick, ref, Ref, watch, Watch, Vue} from "vue";

export default {

    data() {
        return {
            loading: false,
            finished: false,
            //refreshing: false,
            comment: '',
            answer: '',
            memberId: 0,
            enMemberId: 0,
            list: [{key: 'cba', name: '抽篮球', path: '', icon: require('@/assets/cba/clq.png')},
                {key: 'cba', name: '抽门票', path: '', icon: require('@/assets/cba/clqp.png')},
                {key: 'qghd', name: '测试赛', path: '', icon: require('@/assets/cba/ms.png')},
                {key: 'wtlxfq', name: '云上集市', path: '', icon: require('@/assets/cba/ysjs.png')}],
            commentList: [],
            totalCommentLength: 0,
            defaultAvatar:  require('@/assets/cba/avatar.png'),
            commentIcon:  require('@/assets/vote_tips.png'),
            user: {},
            ballExchange: {},
            ticketExchange: {},
            basketEvent: {},
            page: 1,
            pageSize: 5,
            bestComment: '',
            showPopUp: false,
            commentId: 0,
            infoCollect: false,
            name: '',
            card: '',
        };
    },
    methods: {
        sendComment: function () {
            console.log("memberId:",  this.memberId);
            if(this.comment !== '') {
                this.$api.sendBasketComment({
                    params: {
                        memberId: this.memberId,
                        comment: this.comment,
                    },
                    success: function (res) {
                        console.log(":::success", res)
                        Toast('审核中');
                        this.comment = '';
                    }.bind(this),
                    fail: function (res) {
                        console.log(":::fail", res)
                        Toast('许愿失败');
                    }
                })
            }else{
                Toast('请先输入愿望');
            }
        },
        scoreChange(exchangeName){
            this.$router.push({
                path: '/dycbaexchange',
                query: {
                    memberId: this.user.memberId,
                    exchangeName: '',
                }
            })
        },
        onLoad () {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                this.$api.getBasketCommentList({
                    params: {
                        'state': '1',
                        'page': this.page,
                        'pageSize': this.pageSize
                    },
                    success: function (res) {
                        if (res.code === 0 && Array.isArray(res.data)) {
                            this.commentList.push(...res.data)
                            console.log(":::commentList", res.data)
                            // 加载状态结束
                            this.loading = false;
                            this.page ++;
                        }

                    }.bind(this),
                })
                //数据全部加载完成
                if (this.commentList.length >= this.totalCommentLength) {
                    this.finished = true;
                }
            }, 1000);
        },
        //点赞
        clickFavor(item){
            console.log(":::item:", item)
            this.$api.clickFavor({
                params: {
                    memberId: this.memberId,
                    commentId: item.id,
                },
                success: function (res) {
                    console.log(":::FavorState:", res.data)
                    if(res.data === 1){
                        Toast.success('点赞成功')
                        item.favorNum ++
                    }else{
                        Toast.fail('取消点赞')
                        item.favorNum --
                    }
                }.bind(this)
            })
        },
        dataTransfer(comment){
            this.showPopUp = true;
            this.commentId = comment.id;
        },
        //评论回复
        answerComment(){
            console.log(":::commentId:", this.commentId)
            console.log(":::answer:", this.answer)
            console.log(":::memberId:", this.memberId)
            if(this.answer === ''){
                Toast('请输入回复');
            }else {
                this.$api.answerComment({
                    params: {
                        commentId: this.commentId,
                        answerUserId: this.memberId,
                        answer: this.answer,
                    },
                    success: function (res) {
                        console.log(":::answerState:", res.data)
                        Toast('审核中');
                        this.showPopUp = false;
                        this.answer = '';
                    }.bind(this)
                })
            }
        },
        submitUser(){
            console.log(":::name:", this.name)
            console.log(":::card:", this.card)
            if(this.name === ''){
                Toast('请填写真实姓名');
            } else if(this.card === ''){
                Toast('请填写身份证号');
            } else {
                this.$api.submitRealUser({
                    params: {
                        memberId: this.memberId,
                        name: this.name,
                        card: this.card,
                    },
                    success: function (res) {
                        console.log(":::res:", res.data)
                        Toast('提交成功');
                        this.infoCollect = false;
                        this.name = '';
                        this.card = '';
                    }.bind(this)
                })
            }
        },
        //进入评论列表页面
        goCommentList(item){
            console.log(":::item.id:", item.id)
            this.$router.push({
                path: '/dycbaCommentList',
                query: {
                    answerUserId: this.user.memberId,
                    commentId: item.id,
                }
            })
        },
        goto(eventName){
            console.log(":::eventName:", eventName)
            let path = ''
            let flag = 0    //0:全查 1:查篮球 2:查篮球票
            if(eventName === '抽篮球') {
                path = '/cbaTicketLists';
                flag = 1;
            }
            if(eventName === '抽门票') {
                path = '/cbaTicketLists';
                flag = 2;
            }
            if(eventName === '测试赛') path = '/antigensLists'
            if(eventName === '云上集市') path = '/couponLists'
            if(eventName !== '云上集市') {
                this.$api.getRealUser({
                    params: {
                        memberId: this.memberId,
                    },
                    success: function (res) {
                        console.log(":::res:", res.data)
                        //用户信息未收集
                        if(res.data === 0){
                            Dialog.alert({
                                message: '因安保需要，请如实填写以下信息，方能进入抢票页面',
                                theme: 'round-button',
                            }).then(() => {
                                this.infoCollect = true;
                            });
                        }else{
                            if(this.infoCollect == false) {
                                this.$router.push({
                                    path: `${path}`,
                                    query: {
                                        memberId: this.enMemberId,
                                        flag: flag,
                                    }
                                })
                            }
                        }
                    }.bind(this)
                })
            }else{
                //Toast('暂未开通');
                this.$router.push({
                    path: `${path}`,
                    query: {
                        memberId: this.enMemberId,
                    }
                })
            }
        }
    },
    created(){
        this.memberId = this.$route.query.memberId
        this.enMemberId = this.$route.query.enMemberId
        console.log("--memberId:", this.memberId)
        console.log("--enMemberId:", this.enMemberId)
    },
    mounted() {
        let vanEnd = this.$refs.vanEnd.$el;
        if(this.$store.state.vanEnd !== 0){
            vanEnd.style.top = this.$store.state.vanEnd;
        }else{
            let vanStart = this.$refs.vanStart.$el;
            vanEnd.style.top = vanStart.getBoundingClientRect().bottom +55+ 'px';
            this.$store.commit("updateVanEnd", vanEnd.style.top)
        }

        this.$api.getTotalCommentList({
            params: {
                'state': '1',
            },
            success: function (res) {
                console.log(":::TotalCommentList:", res.data)
                this.totalCommentLength = res.data.length;
            }.bind(this)
        }),
        this.$api.getTotalScoreInfo({
            params: {
                memberId: this.memberId,
            },
            success: function (res) {
                console.log(":::res:", res.data)
                this.user = res.data.user
                this.ballExchange = res.data.ball
                this.ticketExchange = res.data.ticket
                this.basketEvent = res.data.event
                console.log(":::user:", this.user)
                console.log(":::ballExchange:", this.ballExchange)
                console.log(":::backetExchange:", this.ticketExchange)
                console.log(":::basketEvent:", this.basketEvent)
                let bestComment = this.basketEvent.bestComment === '' ? '暂无' : this.basketEvent.bestComment;
                this.bestComment = '昨日最佳：' + bestComment;
                console.log(":::bestComment:", this.bestComment)
                let { loginScore, commentScore, scoreLimit } = this.basketEvent
                if(this.$store.state.firstLoad === 1) {
                    // Dialog.alert({
                    //     message: `欢迎来到CBA丹阳赛区，用户每日登录APP可获得${loginScore}积分，发布一个愿望审核通过后可得${commentScore}积分，发布愿望每日最高可得${scoreLimit}积分。期待您的支持。`,
                    //     theme: 'round-button',
                    // }).then(() => {
                    //     // on close
                    // });
                }
            }.bind(this)
        })
    },
    unmounted() {
        console.log(":::firstLoad:",  this.$store.state.firstLoad)
        this.$store.commit("updateFirstLoad", 0)
        console.log(":::firstLoad:",  this.$store.state.firstLoad)
    }
};
